import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchPasskeyPreferencesUser } from '../api';
import {
  passkeyPreferencesFailure,
  passkeyPreferencesRequest,
  passkeyPreferencesSuccess,
} from '../reducer/passkeyOtpPreferencesSlice';

const isSuccessStatus = (response: any): boolean =>
  response?.statusCode === '200' ||
  response?.statusCode === 200 ||
  response?.status === 200 ||
  response?.status === '200';

export function* fetchPasskeyPreferencesSaga(
  action: ReturnType<typeof passkeyPreferencesRequest>
): Generator<any, void, unknown> {
  try {
    const response: any = yield call(
      fetchPasskeyPreferencesUser,
      action.payload
    );
    if (isSuccessStatus(response)) {
      yield put(passkeyPreferencesSuccess(response));
    } else {
      yield put(passkeyPreferencesFailure(response));
    }
  } catch (error: any) {
    yield put(passkeyPreferencesFailure(error));
  }
}

export function* watchPasskeyOtpPreferencesSaga() {
  yield takeLatest(passkeyPreferencesRequest.type, fetchPasskeyPreferencesSaga);
}
